<template>
  <section class="listing">
    <i v-if="loading" class="fas fa-spinner loading-big"></i>
    <div v-show="!loading" class="content">
      <div class="wrapper">
        <div class="cards">
          <div class="left">
            <div class="card card1">
              <div class="card-content">
                <div class="label">Hoje ficou disponível para você:</div>
                <div class="value">R$ 0,00</div>
              </div>
            </div>
            <div class="card card2">
              <div class="card-content">
                <div class="label">Total de valores futuros a receber</div>
                <div class="value">{{futureValue.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}}</div>
                <!-- <div class="action "><Button class="disabled">Solicitar antecipação</Button></div> -->
              </div>
            </div>
          </div>
          <div class="right">
            <div class="card card3">
              <div class="card-content">
                <div class="label">Valor disponivel em sua conta:</div>
                <div class="value primary1" style="font-size: 4em">{{availableValue.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}}</div>
                <div class="action">
                  <button>Retirar dinheiro</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card months">
          <div class="label">Valores futuros a receber mês a mês</div>
          <div class="month-wrapper">
            <div class="month" v-for="(futureMonth, i) in filteredMonths" :key="i">
              <div class="label">{{months[futureMonth.month]}}</div>
              <div class="value">{{futureMonth.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}}</div>
            </div>
          </div>
        </div>

        <div class="calendar">
          <div class="card month">
            <div class="header">
              <div class="label">Calendário de recebíveis</div>
              <div class="title-wrapper">
                <div class="content">
                  <div class="calendar-legend">
                    <div class="calendar-green"><span>Creditados</span></div>
                    <div class="calendar-red"><span>Debitados</span></div>
                    <div class="calendar-orange"><span>Futuros</span></div>
                    <div class="calendar-gray"><span>Retirados</span></div>
                  </div>
                  <div class="month-header">
                    <div @click="changeMonth(-1)">
                      <i class="fas fa-angle-left"></i>
                    </div>
                    <span> {{ monthString }} </span>
                    <div  @click="changeMonth(1)">
                      <i class="fas fa-angle-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <v-calendar
              ref='calendar'
              class="month-picker"
              is-expanded
              @dayclick="daySelect"
              :attributes="calendarAtributes"
              :to-date="today"
            />
          </div>
          <div class="card day">
            <div class="header">
              <div @click="changeDay(-1)">
                <i class="fas fa-angle-left"></i>
              </div>
              <div class="title">
                <span>{{`${today.getDate()} de ${months[today.getMonth()].toLowerCase().substring(0, 3)}.`}}</span>
                <label>{{days[today.getDay()].toLowerCase()}}</label>
              </div>
              <div @click="changeDay(1)">
                <i class="fas fa-angle-right"></i>
              </div>
            </div>
            <div class="content">
              <div class="day-wrapper">
                <div v-if="selectedDay">
                  <div v-for="(event, i) in selectedDay.attributes" :key="i">
                    <div v-if="event.customData">
                      <div class="label">{{event.customData.label}}</div>
                      <div class="value" :style="{color: event.customData.color}">
                        {{event.customData.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}}
                      </div>
                        <div v-if="event.customData && event.customData.date" class="details">
                          <span @click="setDetails(i)" style="cursor: pointer">
                            Mostrar detalhes
                            <button :class="{'active': !event.customData.details}"> > </button>
                          </span>
                          <div v-if="event.customData &&
                            event.customData.details &&
                            event.customData.date" class="details-items">
                            <span class="date">
                              {{ new Date(event.customData.date).toLocaleString('pt-br').split(' ')[1]}}
                            </span>
                            <div v-if="event.customData.info">
                              <span>
                                <div>Retirado:</div>
                                <div>{{ event.customData.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</div>
                              </span>
                              <span>
                                <div>Taxa:</div>
                                <div>{{ ((event.customData.info.fee_amount * -1) / 100).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</div>
                              </span>
                              <span>
                                <div>Transferido:</div>
                                <div>{{ ((event.customData.info.transferred_amount * -1) / 100).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</div>
                              </span>
                            </div>
                            <div>
                              <span>
                                <div>Creditado:</div>
                                <div>{{event.customData.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}}</div>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- default size width 1140 -->
  </section>
</template>

<script>
import {
  getBalanceSumary,
  getBalanceByDate,
  getFutureYearBalances
} from '../api/financial'

export default {
  name: 'financeTest',
  data () {
    return {
      loading: true,
      details: false,
      currentMonth: new Date(),
      relativeMonth: new Date().getMonth(),
      today: new Date(),
      selectedDay: new Date(),
      todayValue: 0.0,
      futureValue: 0.0,
      availableValue: 0.0,
      calendar: '',
      calendarAtributes: [],
      calendarLegendColors: {
        green: '#72ce96',
        red: '#ce553d',
        orange: '#f3994a',
        gray: '#9f9eb0'
      },
      months: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
      ],
      days: [
        'domingo',
        'segunda-feira',
        'terça-feira',
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        'sábado'
      ],
      futureMonths: [
        {
          month: 'Janeiro',
          value: 0.0
        },
        {
          month: 'Fevereiro',
          value: 0.0
        },
        {
          month: 'Março',
          value: 0.0
        },
        {
          month: 'Abril',
          value: 0.0
        },
        {
          month: 'Março',
          value: 0.0
        }

      ]
    }
  },
  computed: {
    monthString () {
      return `${this.months[this.today.getMonth()]}, ${this.today.getFullYear()}`
    },
    currentDate () {
      return this.calendarAtributes.find(x => x.dates.toISOString().split('T')[0] === this.today.toISOString().split('T')[0])
    },
    filteredMonths () {
      return this.futureMonths.filter(x => x.value > 0)
    }
  },
  async mounted () {
    await this.getData()
    this.selectedDay = { attributes: this.calendarAtributes.filter(x => x.key === this.today.toISOString().split('T')[0]) }
    this.loading = false
  },
  methods: {
    // get all balance data
    async getData () {
      const { data } = await getBalanceSumary()
      this.futureMonths = await getFutureYearBalances()
      this.availableValue = data.available / 100
      this.futureValue = data.future / 100
      var date = new Date()
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      await this.getCalendarData(firstDay, lastDay)
      this.calendar = this.$refs.calendar
      this.loading = false
    },
    // getAll balances in a month
    async getCalendarData (firstDay, lastDay) {
      const result = await getBalanceByDate(firstDay, lastDay)
      this.calendarAtributes = result.map(x => {
        let day = {}
        if (x.available.amount > 0) {
          day.dot = 'red'
          day.customData = {
            details: false,
            date: x.available.date,
            color: '#ce553d',
            label: 'Débito',
            value: x.available.amount / 100
          }
          day.popover = {
            label: `Debitado o valor de: ${(x.available.amount / 100).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`
          }
        }
        if (x.credited.amount > 0) {
          day.dot = 'green'
          day.customData = {
            details: false,
            date: x.credited.date,
            color: '#72ce96',
            label: 'Creditado',
            value: x.credited.amount / 100
          }
          day.popover = {
            label: `Creditado o valor de: ${(x.credited.amount / 100).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`
          }
        }
        if (x.future.amount > 0) {
          day.dot = 'orange'
          day.customData = {
            details: false,
            color: '#f3994a',
            label: 'Valor a receber',
            value: x.future.amount / 100
          }
          day.popover = {
            label: `Valor a receber:${(x.future.amount / 100).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`
          }
        }
        if (x.transferred.amount !== 0) {
          day.dot = 'gray'
          day.customData = {
            details: false,
            date: x.transferred.date,
            color: '#9f9eb0',
            label: 'Retirou da sua conta:',
            value: (x.transferred.amount / 100) * -1,
            info: x.transferred.info !== undefined ? JSON.parse(x.transferred.info) : ''
          }
          day.popover = {
            label: `Valor transferido:${(x.transferred.amount / 100).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`
          }
        }
        return {
          key: new Date(x.timestamp).toISOString().split('T')[0],
          dates: new Date(x.timestamp),
          ...day
        }
      })
    },
    // change month in calendar
    async changeMonth (month) {
      this.loading = true
      let currentRelativeMonth = this.relativeMonth

      if (month > 0) currentRelativeMonth++
      else currentRelativeMonth--

      const calendar = this.$refs.calendar
      const copyMonth = this.currentMonth
      copyMonth.setMonth(currentRelativeMonth)
      currentRelativeMonth = copyMonth.getMonth()
      const firstDay = new Date(copyMonth.getFullYear(), copyMonth.getMonth(), 1)
      const lastDay = new Date(copyMonth.getFullYear(), copyMonth.getMonth() + 1, 0)
      await this.getCalendarData(firstDay, lastDay)
      calendar.move(month)

      this.currentMonth.setMonth(currentRelativeMonth)
      this.relativeMonth = this.currentMonth.getMonth()
      this.today = firstDay
      this.selectedDay = { attributes: this.calendarAtributes.filter(x => x.key === this.today.toISOString().split('T')[0]) }
      this.loading = false
    },
    // handler for dayclick in calendar
    daySelect (dayInfo) {
      this.today = dayInfo.date
      this.selectedDay = dayInfo
    },
    // change day in the day section
    // expect day to be 1 or -1, 1 is forward and -1 backwards
    async changeDay (day) {
      const calendar = this.$refs.calendar
      let lastDay = new Date(
        this.today.getFullYear(),
        this.today.getMonth() + 1,
        0
      )
      if (
        this.today.getDate() + day === 0 ||
        this.today.getDate() + day > lastDay.getDate()
      ) {
        let firstDay = new Date(this.today)
        firstDay.setDate(this.today.getDate() + day)
        firstDay = new Date(firstDay.getFullYear(), firstDay.getMonth(), 1)
        lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 1, 0)
        this.loading = true
        await calendar.move(day)
        await this.getCalendarData(firstDay, lastDay)
        this.loading = false
      }
      this.today = new Date(this.today.setDate(this.today.getDate() + day))
      this.selectedDay = this.calendarAtributes.find(x => x.key === this.today.toISOString().split('T')[0])
      if (this.selectedDay && this.selectedDay.customData) {
        this.selectedDay.attributes = this.calendarAtributes
          .filter(
            x => x.key === this.today.toISOString().split('T')[0] &&
            x.customData
          )
          .map(x => {
            return { customData: x.customData }
          })
      }
      calendar.focusDate(this.today)
    },
    setDetails (index) {
      const obj = this.selectedDay.attributes[index]
      obj.customData.details = !obj.customData.details
      this.$set(this.selectedDay.attributes, index, obj)
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .vc-arrows-container { display: none !important; }
  /deep/ .vc-header { display: none !important;}
@import "../_asset/scss/_variables";
  $blue: #2397d4;
  $legend-color-green: #72ce96;
  $legend-color-red: #ce553d;
  $legend-color-orange: #f3994a;
  $legend-color-gray: #9f9eb0;
  $legend-margin: 5px;
  $legend-dot-size: 6px;
  .disabled { background-color: #9ccaeb !important;}
  .primary1 { color: #034986 !important; }

  .card3 {
    .primary1 {
      .value {
        font-size: 4em !important;
      }
    }
  }

  .card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 0px 5px 0px rgb(162, 162, 162);
    border-radius: 7px;
    .value {
      font-weight: bold;
      font-size: 2em;
      color: #313e47;
    }
  }

  .cards {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    :not(:last-child) {
      margin-bottom: 12px;
    }
    .card-content {
      padding: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .label {
        display: flex;
        white-space: pre;
        margin-bottom: 10px;
      }
      .action {
        button {
          border-radius: 30px;
          color: #fff;
          background-color: $blue;
          padding: 7px 15px;
          border: none;
        }
      }
    }
  }

  .right, .left {
    width: 100%;
  }

  .months {
    max-width: 100%;
    margin-top: 10px;
    padding: 10px;
    .label {
      margin-bottom: 10px;
    }
    .month-wrapper {
      overflow: auto;
      max-width: 100%;
      display: flex;
      align-items: center;
      .month {
        margin: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        white-space: pre;
        .label {
          color: #b9b8b6;
        }
      }
    }
  }

  .calendar {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .month {
      .title-wrapper {
        margin: 15px;
      }
      .header {
        display: block;
        width: 100%;
        border-bottom: 1px solid dimgray;
        .label {
          margin: 15px;
          font-weight: 400;
        }
        .content {
          display: flex;
          align-items: center;
          width: 100%;
          margin-bottom: 20px;
          .calendar-legend {

            display: flex;
            width: 100%;
            font-size: 0.8em;
            font-weight: 600;
            :not(:last-child) {
              margin-right: 10px;
            }
            span {
              line-height: 5.7px;
            }

            .calendar-green {
              color: $legend-color-green;
              display: flex;
              align-items: center;
              &::before {
                margin-right: $legend-margin;
                content: '';
                width: $legend-dot-size;
                height: $legend-dot-size;
                background-color: $legend-color-green;
                border-radius: 50%;
              }
            }

            .calendar-red {
              color: $legend-color-red;
              display: flex;
              align-items: center;
              &::before {
                margin-right: $legend-margin;
                width: $legend-dot-size;
                height: $legend-dot-size;
                background-color: $legend-color-red;
                border-radius: 50%;
                content: '';
              }
            }

            .calendar-orange {
              color:  $legend-color-orange;
              display: flex;
              align-items: center;
              &::before {
                margin-right: $legend-margin;
                content: '';
                width: $legend-dot-size;
                height: $legend-dot-size;
                background-color:  $legend-color-orange;
                border-radius: 50%;
              }
            }

            .calendar-gray {
              color:  $legend-color-gray;
              display: flex;
              align-items: center;
              &::before {
                margin-right: $legend-margin;
                content: '';
                width: $legend-dot-size;
                height: $legend-dot-size;
                background-color:  $legend-color-gray;
                border-radius: 50%;
              }
            }
          }
          .month-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            line-height: 1px;
            font-size: 1.5em;
            font-weight: 600;
            white-space: pre;
            width: 400px;
            div { cursor: pointer; }
            span { margin: 0px 20px; }
          }
        }
      }
      width: 100%;
      margin-bottom: 15px;
      .month-picker {
        border: none;
      }
    }
    .day {
      justify-content: flex-start;
      width: 100%;
      .header {
        margin: 15px;
        display: flex;
        align-items: flex-start;
        .fas {
          margin: 10px 16px;
          cursor: pointer;
        }
      }
      .title {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-weight: 600;
        font-size: 1.5em;
        label {
          font-size: 0.5em;
          color: #b9b8b6;
        }
      }
      .content {
        height: 250px;
        overflow: auto;
        .day-wrapper {
          width: 100%;
          margin: 10px;
        }
        .details {
          max-height: 100%;
          button {
            outline: none;
            transition: 0.3s;
            transform: rotate(-90deg);
            border: none;
            padding: 5px;
            background-color: transparent;
            color: $blue;
            cursor: pointer;
            &.active {
              transform: rotate(90deg);
            }
          }
          .date {
            color: $legend-color-gray;
          }
          .details-items {
            width: 190px;
            span {
              display: flex;
              justify-content: space-between;
            }
            border-left: solid #e1e1e1 3px;
            padding-left: 5px;
            display: flex;
            flex-direction: column;
            :not(:last-child) {
              margin-bottom: 2px;
            }
          }
        }
        width: 100%;
        margin: 10px;
      }
    }
  }
  @media screen and (min-width: 1200px) {
    .content {
      display: flex;
      justify-content: center;
      align-items: center;
      .wrapper {
        max-width: 1200px;
        min-width: 1000px;
      }
    }
    .months {
      margin-top: 0px;
    }
    .calendar {
      flex-direction: row;
      .month {
        margin-bottom: 0;
        margin-right: 15px;
        width: calc(60% - 15px);
      }
      .day {
        width: 40%;
        .content {
          align-items: flex-start;
        }
      }
    }
    .cards {
      flex-direction: row;
      justify-content: center;
      width: 100%;
    }

    .left {
      .card {
        padding: 40px;
      }
      margin-right: 15px;
    }

    .right {
      min-height: 100%;
      .card {
        height: calc(100% - 12px);
      }
    }

    .right, .left {
      width: 50%;
    }
  }
</style>
